import { render, staticRenderFns } from "./TableCellWithPhotos.vue?vue&type=template&id=821b8598&"
import script from "./TableCellWithPhotos.vue?vue&type=script&lang=ts&"
export * from "./TableCellWithPhotos.vue?vue&type=script&lang=ts&"
import style0 from "./TableCellWithPhotos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports